var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"community-go-back",on:{"click":_vm.reroute}},[_vm._v(" Start Trading ")])}
var staticRenderFns = []

export { render, staticRenderFns }